/**
 * Dual Company Name Component
 * 
 * Displays company names for temporary employment situations in the format:
 * "Assignment Company (via Temporary Agency)"
 */

import React from 'react';
import { cn } from '@/lib/utils';

interface DualCompanyNameProps {
  assignmentCompany: {
    name: string;
  };
  tempAgency: {
    name: string;
  };
  className?: string;
  showFullFormat?: boolean; // If false, shows only assignment company name
}

export default function DualCompanyName({ 
  assignmentCompany, 
  tempAgency, 
  className,
  showFullFormat = true 
}: DualCompanyNameProps) {
  if (!showFullFormat) {
    return (
      <span className={cn('text-foreground', className)}>
        {assignmentCompany.name}
      </span>
    );
  }

  return (
    <span className={cn('text-foreground', className)}>
      {assignmentCompany.name}
      <span className="text-muted-foreground ml-1">
        (via {tempAgency.name})
      </span>
    </span>
  );
}
